const fonts = {
    PRIMARY: `'Varela Round', sans-serif`,
}

export default fonts
